import { useState } from 'react';
import { LayoutDashboard, Plug, Building2, Users } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { AdminOverviewTab } from '@/components/admin/AdminOverviewTab';
import { ConnectorsTab } from '@/components/admin/ConnectorsTab';
import { DepartmentsTab } from '@/components/admin/DepartmentsTab';
import { ReviewersTab } from '@/components/admin/ReviewersTab';

export function AdminPage() {
  const [activeTab, setActiveTab] = useState('overview');
  const [openConnectorDialog, setOpenConnectorDialog] = useState(false);
  const [openReviewerDialog, setOpenReviewerDialog] = useState(false);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    if (tab === 'connectors') setOpenConnectorDialog(true);
    if (tab === 'reviewers') setOpenReviewerDialog(true);
  };

  return (
    <div className="flex h-full flex-col gap-6 overflow-y-auto p-6">
      <PageHeader
        title="Administration"
        subtitle="Tenant configuration and system management"
      />

      <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as string)}>
        <TabsList variant="line">
          <TabsTrigger value="overview">
            <LayoutDashboard className="mr-1.5 h-3.5 w-3.5" />
            Overview
          </TabsTrigger>
          <TabsTrigger value="connectors">
            <Plug className="mr-1.5 h-3.5 w-3.5" />
            Connectors
          </TabsTrigger>
          <TabsTrigger value="departments">
            <Building2 className="mr-1.5 h-3.5 w-3.5" />
            Departments
          </TabsTrigger>
          <TabsTrigger value="reviewers">
            <Users className="mr-1.5 h-3.5 w-3.5" />
            Reviewers
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview">
          <AdminOverviewTab onTabChange={handleTabChange} />
        </TabsContent>

        <TabsContent value="connectors">
          <ConnectorsTab
            openAddDialog={openConnectorDialog}
            onAddDialogClose={() => setOpenConnectorDialog(false)}
          />
        </TabsContent>

        <TabsContent value="departments">
          <DepartmentsTab />
        </TabsContent>

        <TabsContent value="reviewers">
          <ReviewersTab
            openAddDialog={openReviewerDialog}
            onAddDialogClose={() => setOpenReviewerDialog(false)}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
